import { render, staticRenderFns } from "./consumer.vue?vue&type=template&id=2d352190"
import script from "./consumer.vue?vue&type=script&lang=js"
export * from "./consumer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d352190')) {
      api.createRecord('2d352190', component.options)
    } else {
      api.reload('2d352190', component.options)
    }
    module.hot.accept("./consumer.vue?vue&type=template&id=2d352190", function () {
      api.rerender('2d352190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/users/consumer.vue"
export default component.exports